module.exports = __webpack_public_path__ + "img/LUB00019.d4aa64cf.png";